import { DisplaySection } from "./DisplaySection";

export default DisplaySection;